import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { ConfigState, GetterClass } from '../../../models'
import type { ContextProvider } from '../../../providers'

import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'

export class CurrentInstanceGetter implements GetterClass {
  static execute(this: void, state: ConfigState): Instance | undefined {
    const { instanceId } = CONTAINER.get<ContextProvider>(TYPES.ContextProvider)()
    return instanceId
      ? state.instances.find((instanceConfig: Instance) => instanceConfig.id === instanceId)
      : undefined
  }
}
